export const WALLET_SETUP_ROUTES = {
  WALLET_SETUP: '/wallet/setup',
  OPTIONS: '/wallet/setup/options',
  PASSWORD: '/wallet/setup/password',
  IMPORT_SEED: '/wallet/setup/seed',
  BACKUP_SEED: '/wallet/setup/backup-seed',
  SUCCESS: '/wallet/setup/success',
}
